import React, { Fragment, useState, useEffect } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import Tooltip from '@material-ui/core/Tooltip';
import AlertModal from '../../../../shared/components/Modal';
import ModalStudyMonitors from './ModalStudyMonitors';

const ListStudyMonitorsActions = ({ data,refresh }) => {

    const [showDeleteModal, setDeleteModal] = React.useState(false);
    const [successModal, setSuccessModal] = React.useState(false);
    const [errorModal, setErrorModal] = React.useState(false);
    const [openModal, setOpenModal] = React.useState(false);

    useEffect(() => {

    }, []);

    const updateMonitor = () => {
        setOpenModal(true);
    }

    const questionDeleteMonitor = () => {
        setDeleteModal(true);
    }

    const deleteMonitor = async () => {
        setDeleteModal(false);
        let dataSend = {
            id_monitor:data.data.original.id_monitor
        }
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'monitorese/delete', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error eliminando el Monitor del Estudio Clinico");
            }
        }).then(response => {
            setSuccessModal(true);
        }).catch(err => {
            console.log(err);
            setErrorModal(true);
        })
    }

    return (<Fragment>
        <td role="cell">
            <Tooltip title="Actualizar Monitor">
                <IconButton style={{ fontSize: '15px' }} onClick={() => updateMonitor()}>
                    <FontAwesomeIcon icon={faEdit} />
                </IconButton>
            </Tooltip>

            <Tooltip title="Eliminar Miembro">
                <IconButton style={{ fontSize: '15px' }} onClick={() => questionDeleteMonitor(true)}>
                    <FontAwesomeIcon icon={faTrashAlt} />
                </IconButton>
            </Tooltip>
        </td>

        
        <ModalStudyMonitors
            openModal={openModal}
            closeModal={() => setOpenModal(false)}
            refresh={refresh}
            dataMonitor={data.data.original}
            idStudy={data.data.original.id_estudio}
        />

        <AlertModal
            color="warning"
            title="Esta seguro de eliminar este monitor del Estudio?"
            modal={showDeleteModal}
            onOk={() => deleteMonitor()}
            toggle={() => setDeleteModal(false)}
        />

        <AlertModal
            color="success"
            title="Monitor del Estudio Eliminado Correctamente"
            modal={successModal}
            onOk={() => {
                refresh();
                setSuccessModal(false);
            }}
            toggle={() => setSuccessModal(false)}
        />

        <AlertModal
            color="danger"
            title="Ha ocurrido un error al eliminar el Monitor del Estudio"
            modal={errorModal}
            onOk={() => setErrorModal(false)}
            toggle={() => setErrorModal(false)}
        />
    </Fragment>)
}

export default ListStudyMonitorsActions;